import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import MiniBitCompressor from './pages/MiniBitCompressor';
import About from './pages/About';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route  path="/" element={<App/>}/>
        <Route  path="/about" element={<About/>}/>
        <Route  path="/minibit" element={<MiniBitCompressor/>}/>
      </Routes>
    </Router>
  </React.StrictMode>
);
